import {
  Component,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { SourceDoc } from '../../interfaces/chart-details.interface';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-article-card-wrapper',
  templateUrl: './chat-article-cards-wrapper.component.html',
  styleUrls: ['./chat-article-cards-wrapper.component.scss'],
})
export class ArticleCardWrapperComponent implements OnInit {
  @Input() sourceDocuments: SourceDoc[];
  @Input() companyName: string;
  @Input() requestedEntities: string[];
  @Input() companyType: string[];
  @Input() entitiyName: string;
  @Output() navigateToCompany = new EventEmitter<{
    companyName: string;
    companyType: string;
  }>();
  @Output() showTheArticleView = new EventEmitter<{
    article: SourceDoc;
    companyName: string;
    companyType: string;
  }>();
  @Input() chartVisible: string;
  relatedArticles: SourceDoc[] = [];
  constructor() {}

  navigateToArticleCompany(companyName: string, companyType: string) {
    this.navigateToCompany.emit({ companyName, companyType });
  }

  triggerArticleView(
    companyName: string,
    companyType: string,
    article: SourceDoc,
  ) {
    this.showTheArticleView.emit({
      companyName,
      companyType: companyType,
      article,
    });
  }

  ngOnInit(): void {
    this.relatedArticles = this.filterDisplayedArticles(this.sourceDocuments);
  }

  private filterDisplayedArticles(sourceDocuments: SourceDoc[]): SourceDoc[] {
    const filteredArticles = sourceDocuments?.filter((article) => {
      if (article.citation) {
        return article;
      }
    });

    return filteredArticles;
  }
}
